import { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import withPermissionProtection from 'hoc/withPermissionProtection';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import ErrorBoundary from 'components/ErrorBoundary';
import Controls from './Controls';
import Banks from './Banks';
import Errors from './Errors';

import SnackbarContext from 'context/Snackbar/Context';
import useGetBanksErrors from './hooks/useGetBanksErrors';

const useStyles = makeStyles(({ palette, breakpoints }) => ({
  header: {
    marginTop: 40,
    marginBottom: 0,
    [breakpoints.up('lg')]: {
      fontSize: 48,
      lineHeight: '56px',
    },
  },
  link: {
    color: palette.cncUI.misc.link,
  },
}));

const PlaidStatus = () => {
  const classes = useStyles();
  const notify = useContext(SnackbarContext);
  const [data, setData] = useState({ banks: [], errors: [] });
  const [loading, setLoading] = useState(false);
  const queryData = useGetBanksErrors();

  const search = value => {
    setLoading(true);
    queryData(value)
      .then(response => setData(response))
      .catch(err => {
        notify({
          show: true,
          type: 'error',
          title: 'Error ocurred',
          message: err.message,
        });
      })
      .finally(() => setLoading(false));
  };

  const clear = () => {
    setData({ banks: [], errors: [] });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} id="HeaderTitle">
        <Typography variant="h2" className={classes.header}>
          Plaid Bank Institution Status
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" size="long" id="HeaderDescription">
          To retrieve bank institution status, you only require the user’s
          Email.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Controls onSearch={search} loading={loading} clear={clear} />
      </Grid>
      <Grid item xs={12}>
        <ErrorBoundary alert>
          <Banks banks={data.banks || []} />
        </ErrorBoundary>
      </Grid>
      <Grid item xs={12}>
        <ErrorBoundary alert>
          <Errors errors={data.errors || []} />
        </ErrorBoundary>
      </Grid>
    </Grid>
  );
};

export default withPermissionProtection('employee_registrations:read')(
  PlaidStatus,
);
